import { useEffect } from 'react';
import { YR, DOY } from '../lib/dateState.js';
import { t as tr } from '../lib/i18n.js';
export function NavIcon({type,active,ac,soft,size=23}){
  const fillCol=active?ac:"none";
  const strokeCol=active?ac:soft;
  const glyphCol=active?"#fff":soft;
  const shapes={
    // Open book — two pages + spine + hint of text lines. Reads instantly as "feed of pages".
    feed:(<>
      <path d="M2.2 6C2.2 5.1 2.9 4.4 3.8 4.4H9.3V15.6H3.8C2.9 15.6 2.2 14.9 2.2 14V6Z" fill={fillCol} stroke={strokeCol} strokeWidth="1.4" strokeLinejoin="round"/>
      <path d="M17.8 6C17.8 5.1 17.1 4.4 16.2 4.4H10.7V15.6H16.2C17.1 15.6 17.8 14.9 17.8 14V6Z" fill={fillCol} stroke={strokeCol} strokeWidth="1.4" strokeLinejoin="round"/>
      <line x1="4.3" y1="7.6" x2="7.5" y2="7.6" stroke={glyphCol} strokeWidth="1" opacity=".7" strokeLinecap="round"/>
      <line x1="4.3" y1="9.8" x2="7.5" y2="9.8" stroke={glyphCol} strokeWidth="1" opacity=".5" strokeLinecap="round"/>
    </>),
    // Camera — body, lens, viewfinder bump. Universally readable as "capture".
    capture:(<>
      <rect x="2" y="6.3" width="16" height="10.4" rx="2.2" fill={fillCol} stroke={strokeCol} strokeWidth="1.4"/>
      <rect x="7.3" y="3.5" width="5.4" height="3" rx="1" fill={fillCol} stroke={strokeCol} strokeWidth="1.3"/>
      <circle cx="10" cy="11.6" r="3.1" fill={active?"#fff":"none"} stroke={strokeCol} strokeWidth="1.4"/>
      <circle cx="10" cy="11.6" r="1.05" fill={active?ac:glyphCol}/>
    </>),
    // Small book with a "+" badge — a mini/extra book, distinct from the open book of Feed.
    micro:(<>
      <rect x="2.3" y="5" width="10" height="13" rx="1.3" fill={fillCol} stroke={strokeCol} strokeWidth="1.4"/>
      <line x1="5.1" y1="5" x2="5.1" y2="18" stroke={glyphCol} strokeWidth="1" opacity=".55"/>
      <circle cx="15.2" cy="6.2" r="3.4" fill={active?ac:"none"} stroke={strokeCol} strokeWidth="1.3"/>
      <line x1="13.6" y1="6.2" x2="16.8" y2="6.2" stroke={active?"#fff":glyphCol} strokeWidth="1.2" strokeLinecap="round"/>
      <line x1="15.2" y1="4.6" x2="15.2" y2="7.8" stroke={active?"#fff":glyphCol} strokeWidth="1.2" strokeLinecap="round"/>
    </>),
    // Spiral-bound journal — closed book with binding rings + ruled lines. Distinct from Feed/Micro.
    notebook:(<>
      <rect x="4.6" y="3.6" width="12.6" height="14.8" rx="1.4" fill={fillCol} stroke={strokeCol} strokeWidth="1.4"/>
      <circle cx="4.6" cy="6.5" r=".85" fill={strokeCol}/>
      <circle cx="4.6" cy="9.7" r=".85" fill={strokeCol}/>
      <circle cx="4.6" cy="12.9" r=".85" fill={strokeCol}/>
      <line x1="8" y1="8" x2="14.5" y2="8" stroke={glyphCol} strokeWidth="1" opacity=".6" strokeLinecap="round"/>
      <line x1="8" y1="11" x2="14.5" y2="11" stroke={glyphCol} strokeWidth="1" opacity=".45" strokeLinecap="round"/>
      <line x1="8" y1="14" x2="12" y2="14" stroke={glyphCol} strokeWidth="1" opacity=".3" strokeLinecap="round"/>
    </>),
    // Magnifying glass — the clearest possible "discover/search" silhouette.
    discover:(<>
      <circle cx="8.6" cy="8.6" r="5.4" fill={active?ac:"none"} stroke={strokeCol} strokeWidth="1.7"/>
      <line x1="12.6" y1="12.6" x2="17.3" y2="17.3" stroke={strokeCol} strokeWidth="1.9" strokeLinecap="round"/>
      {active&&<circle cx="8.6" cy="8.6" r="1.3" fill="#fff"/>}
    </>),
    // Person bust — head + shoulders, the universal profile mark.
    profile:(<>
      <circle cx="10" cy="7" r="3.1" fill={fillCol} stroke={strokeCol} strokeWidth="1.4"/>
      <path d="M3.4 18C3.4 13.6 6.4 11 10 11C13.6 11 16.6 13.6 16.6 18" fill={fillCol} stroke={strokeCol} strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
    </>),
    // Speech bubble with dots — chat, distinct rounded-tail silhouette.
    chat:(<>
      <path d="M4.3 4.6H15.7C16.9 4.6 17.8 5.5 17.8 6.7V12.3C17.8 13.5 16.9 14.4 15.7 14.4H9.4L5.6 17.4V14.4H4.3C3.1 14.4 2.2 13.5 2.2 12.3V6.7C2.2 5.5 3.1 4.6 4.3 4.6Z" fill={fillCol} stroke={strokeCol} strokeWidth="1.4" strokeLinejoin="round"/>
      <circle cx="7" cy="9.5" r=".85" fill={glyphCol}/>
      <circle cx="10" cy="9.5" r=".85" fill={glyphCol}/>
      <circle cx="13" cy="9.5" r=".85" fill={glyphCol}/>
    </>),
    // Equalizer sliders — a settings/adjust motif, unmistakably different from everything else.
    settings:(<>
      <line x1="2.5" y1="5.5" x2="17.5" y2="5.5" stroke={strokeCol} strokeWidth="1.6" strokeLinecap="round"/>
      <circle cx="12.5" cy="5.5" r="2.1" fill={fillCol} stroke={strokeCol} strokeWidth="1.3"/>
      <line x1="2.5" y1="10.3" x2="17.5" y2="10.3" stroke={strokeCol} strokeWidth="1.6" strokeLinecap="round"/>
      <circle cx="7" cy="10.3" r="2.1" fill={fillCol} stroke={strokeCol} strokeWidth="1.3"/>
      <line x1="2.5" y1="15.1" x2="17.5" y2="15.1" stroke={strokeCol} strokeWidth="1.6" strokeLinecap="round"/>
      <circle cx="13.6" cy="15.1" r="2.1" fill={fillCol} stroke={strokeCol} strokeWidth="1.3"/>
    </>),
    // Open tray with an arrow lifting out — "send this beyond Oncer". Distinct from the chat bubble.
    share:(<>
      <path d="M4 10.5V15C4 16.1 4.9 17 6 17H14C15.1 17 16 16.1 16 15V10.5" fill="none" stroke={strokeCol} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M10 13.2V3.3M10 3.3L6.6 6.7M10 3.3L13.4 6.7" fill="none" stroke={strokeCol} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
    </>),
    // Aeroplanino di carta — "invia questa pagina a qualcuno dentro Oncer",
    // distinto dal fumetto (chat) usato per Notebook/notifiche: qui serve
    // proprio il gesto dell'invio, non una conversazione generica.
    send:(<>
      <path d="M17.5 2.5L2 9.2C1.6 9.4 1.6 9.9 2 10.1L7.8 12.4L10.1 18.2C10.3 18.6 10.8 18.6 11 18.2L17.7 3C17.9 2.6 17.9 2.3 17.5 2.5Z" fill={fillCol} stroke={strokeCol} strokeWidth="1.4" strokeLinejoin="round" strokeLinecap="round"/>
      <path d="M17.5 2.5L7.8 12.4" stroke={strokeCol} strokeWidth="1.3" strokeLinecap="round"/>
    </>),
    // Bell — classic dome + flared base + small clapper arc underneath. Used for notifications.
    bell:(<>
      <path d="M10 3C7.8 3 6.1 4.8 6.1 7V10.4L4.4 13.1C4.1 13.6 4.4 14.2 5 14.2H15C15.6 14.2 15.9 13.6 15.6 13.1L13.9 10.4V7C13.9 4.8 12.2 3 10 3Z" fill={fillCol} stroke={strokeCol} strokeWidth="1.4" strokeLinejoin="round"/>
      <path d="M8.3 16.3C8.3 17.2 9.1 17.9 10 17.9C10.9 17.9 11.7 17.2 11.7 16.3" fill="none" stroke={strokeCol} strokeWidth="1.4" strokeLinecap="round"/>
    </>),
  };
  return(
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none">
      {shapes[type]}
    </svg>
  );
}
// La barra è "sospesa": un guscio trasparente (flexShrink:0) riserva lo
// spazio in basso esattamente come prima (nessun'altra schermata deve
// cambiare il proprio padding/scroll), ma dentro quello spazio la barra
// VERA è un pillolo assoluto, staccato dai bordi laterali e sollevato da
// quello inferiore — non più incollata al fondo su tutta la larghezza.
// L'ombra a due strati (una ampia e sfumata sotto, una più stretta e
// scura vicino al bordo) è quello che dà l'effetto di "galleggiare" sopra
// il contenuto invece di essere incastrata nello schermo. animation
// navFloatIn la fa entrare con un piccolo sollevamento ad ogni cambio di
// schermata (si rimonta ogni volta, essendo dentro ogni singola view) —
// non è un loop continuo apposta, per non essere fastidiosa nell'uso
// quotidiano.
// Solo icone, niente scritte sotto (tolte per liberare spazio e permettere
// icone più leggibili con 6 sezioni in fila) — l'etichetta resta comunque
// in aria-label per l'accessibilità.
// Il pillolo è largo solo quanto il suo contenuto (non più stirato da bordo
// a bordo con "left/right:10"), centrato con left:50%+translateX(-50%), con
// uno spazio FISSO e stretto tra le icone (gap, non space-between) — su un
// telefono vero, molto più largo del riquadro usato nelle anteprime, uno
// space-between su tutta la larghezza allargava troppo gli spazi tra le
// icone. Così la distanza tra icone e dai bordi resta identica e compatta
// indipendentemente dalla larghezza dello schermo.
// zIndex esplicito SIA sul guscio esterno che sul pillolo interno: prima
// solo il pillolo aveva uno zIndex proprio, e in certi casi (es. la firma
// "Oncer · anno" sulle foto nel Feed, che ha un suo z-index locale) il
// guscio senza zIndex proprio non garantiva di restare sopra al contenuto
// scorrevole sottostante. Ora è inequivocabile: entrambi i livelli stanno
// sopra a tutto quello che scorre sotto.
// Il guscio esterno DEVE restare "sticky" (non "relative"): in schermate
// come Feed.jsx è l'intero .screen a scorrere (scrollRef è sull'elemento
// più esterno, non su un div interno separato) — senza sticky la barra
// scorre via col resto del contenuto invece di restare agganciata in fondo
// alla vista. "sticky" resta comunque valido come "positioned" per il
// pillolo assoluto dentro di esso, quindi il guscio si aggancia in basso E
// il pillolo fluttua dentro di lui esattamente come prima.
// fixed=true (31/08/2026): usata dalla SINGOLA istanza condivisa in App.jsx,
// montata FUORI dalle 6 sezioni a scorrimento — lì "sticky" non serve più
// (non c'è nessun contenitore che scorre intorno a lei, è lei stessa ferma
// sopra a tutto) e va sostituito con "absolute", altrimenti finirebbe in
// cima invece che in fondo. Le istanze ancora usate localmente (Library,
// Filters, Goals — schermate raggiunte con un tocco, senza curva) restano
// col comportamento di sempre, fixed non passato/false.
export function BNav({items,t,fixed}){
  return(
    <div style={{flexShrink:0,height:"calc(64px + env(safe-area-inset-bottom,0px))",position:fixed?"absolute":"sticky",bottom:0,left:fixed?0:undefined,right:fixed?0:undefined,zIndex:30}}>
      <div style={{
        position:"absolute",left:"50%",transform:"translateX(-50%)",bottom:"calc(10px + env(safe-area-inset-bottom,0px))",
        zIndex:30,display:"flex",justifyContent:"center",alignItems:"center",gap:16,
        padding:"9px 16px",borderRadius:20,
        // Vetro rifatto il 31/08/2026 (richiesta di Matte, validata dal vivo
        // su prototipi in chat): meno opaco di prima (F0→9E) e con
        // saturate() oltre al blur, altrimenti il colore che passa sotto
        // sbiadisce verso il grigio invece di restare vivo — bordo e
        // riflessi più marcati così si legge come vetro anche su sfondi
        // scuri molto simili al colore del tema. Ritoccato ancora lo stesso
        // giorno: altro 15% di trasparenza (9E→78) per intravedere meglio
        // lo scroll verticale sotto — stesso valore usato anche
        // sull'intestazione del Feed (vedi Feed.jsx), apposta uguali.
        background:t.bg+"78",backdropFilter:"blur(26px) saturate(200%)",WebkitBackdropFilter:"blur(26px) saturate(200%)",
        border:`1px solid ${t.ac}40`,
        boxShadow:`0 16px 32px rgba(0,0,0,.32),0 3px 10px rgba(0,0,0,.24),inset 0 1.5px 0 rgba(255,255,255,.16),inset 0 -1px 0 rgba(0,0,0,.18)`,
        animation:"navFloatIn .32s cubic-bezier(.4,0,.2,1)",
      }}>
        {items.map(it=>(
          <div key={it.label} onClick={()=>{console.log("Oncer: tocco barra in basso —",it.label);it.fn();}} role="button" aria-label={it.label} aria-current={it.active?"page":undefined} style={{display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer",position:"relative",padding:"3px"}}>
            {it.active&&<div style={{position:"absolute",top:"50%",left:"50%",transform:"translate(-50%,-50%)",width:32,height:32,borderRadius:"50%",background:`${t.ac}22`}}/>}
            <div style={{position:"relative",transition:"transform .28s cubic-bezier(.34,1.56,.64,1)",transform:it.active?"translateY(-1.5px) scale(1.08)":"none"}}>
              <NavIcon type={it.iconType} active={it.active} ac={t.ac} soft={t.soft} size={24}/>
              {(it.badge||0)>0&&<div style={{position:"absolute",top:-3,right:-5,width:13,height:13,borderRadius:"50%",background:t.ac,display:"flex",alignItems:"center",justifyContent:"center",fontSize:8,fontWeight:700,color:"#fff",boxShadow:`0 0 0 2px ${t.bg}`}}>{it.badge}</div>}
              {!(it.badge>0)&&it.dot&&<div style={{position:"absolute",top:0,right:-1,width:8,height:8,borderRadius:"50%",background:t.ac,boxShadow:`0 0 0 2px ${t.bg}`}}/>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
export function mainNavItems(active,t,go,st){
  const demoUnread=(st?.threads||[]).reduce((a,b)=>a+b.unread,0);
  const unread=demoUnread+(st?.unreadThreadsReal||0);
  const notPostedToday=!(st?.books?.[YR]?.pages?.some(p=>p.day===DOY));
  const hasNewFeed=(st?.feed||[]).some(item=>item.real&&item.ts>(st?.lastFeedViewedAt||0));
  return [
    {iconType:"feed",    label:tr("nav_feed"),    active:active==="feed",    fn:()=>go("feed"),    dot:hasNewFeed},
    {iconType:"capture", label:tr("nav_capture"), active:active==="capture", fn:()=>go("capture"), dot:notPostedToday},
    {iconType:"micro",   label:tr("nav_micro"),   active:active==="micro",   fn:()=>go("micro"), dot:(st?.pendingInvites||[]).length>0},
    {iconType:"notebook",label:tr("nav_notebook"),active:active==="notebook",fn:()=>go("notebook"),badge:unread},
    {iconType:"discover",label:tr("nav_discover"),active:active==="discover",fn:()=>go("discover")},
    {iconType:"profile", label:tr("nav_profile"), active:active==="profile", fn:()=>go("profile_me")},
  ];
}
export function ToastDisplay({toast,dispatch}){
  useEffect(()=>{
    if(!toast) return;
    const timer=setTimeout(()=>dispatch({type:"HIDE_TOAST"}),3200);
    return ()=>clearTimeout(timer);
  },[toast&&toast.id]);
  if(!toast) return null;
  const isError=toast.kind==="error";
  return(
    <div style={{position:"fixed",bottom:92,left:"50%",transform:"translateX(-50%)",zIndex:200,background:isError?"#D93025":"#1a1a1a",color:"#fff",padding:"11px 20px",borderRadius:40,fontSize:12.5,fontFamily:"Inter,sans-serif",fontWeight:600,boxShadow:"0 8px 24px rgba(0,0,0,.4)",maxWidth:"86%",textAlign:"center",display:"flex",alignItems:"center",gap:8,animation:"toastIn .25s cubic-bezier(.34,1.56,.64,1)"}}>
      <span style={{flexShrink:0}}>{isError?"⚠️":"✓"}</span>
      <span>{toast.message}</span>
    </div>
  );
}
